export default __webpack_public_path__ + "static/media/logo-riksbanken.366acaa3.png";